import type { MigrationManifest } from '@ms/yammer-data/dist/persistedState';
import { createMigrate, getPersistConfig } from '@ms/yammer-data/dist/persistedState';
import { initialState as pushNotificationsSettingsInitialState } from '@ms/yammer-data/dist/state/pushNotificationsSettings/reducer';
import { getItem, setItem } from '@ms/yammer-session-storage';
import { getNetworkContext } from '@ms/yammer-web-support/dist/location';

import type { YammerWebState } from '../../state/types';

export const persistConfigKey = `PersistConfigKey`;

type SetPersistConfigKey = (key: string) => void;
const setPersistConfigKey: SetPersistConfigKey = (key) => {
  setItem<string>(persistConfigKey, key);
};

type GetPersistConfigKey = () => string | null;
const getPersistConfigKey: GetPersistConfigKey = () => getItem<string>(persistConfigKey);

export const getKey = () => {
  let key = 'web';
  const networkContext = getNetworkContext(window.location.pathname);
  if (networkContext?.networkType === 'Canonical') {
    const tenantFromPath = networkContext.permalink;

    if (tenantFromPath != null) {
      key = `${key}-${tenantFromPath}`;
      setPersistConfigKey(key);

      return key;
    }
  }

  const persistKey = getPersistConfigKey();
  if (persistKey != null) {
    return persistKey;
  }

  setPersistConfigKey(key);

  return key;
};

const migrations = {
  0: (state: YammerWebState) => ({
    ...state,
    pushNotificationsSettings: {
      ...pushNotificationsSettingsInitialState,
      ...state.pushNotificationsSettings,
    },
  }),
};

export const persistConfig = getPersistConfig<YammerWebState>({
  key: getKey(),
  version: 0,
  migrate: createMigrate(migrations as unknown as MigrationManifest, { debug: false }),
  allowlist: ['ecsConfig', 'ecsExperiments', 'ecsFeatureRollouts', 'pushNotificationsSettings', 'suiteHeaderTheme'],
});
